function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon-kefu");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "8.69191347%",
  y1: "23.5367327%",
  x2: "84.0521079%",
  y2: "83.8350231%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4BE4FF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#168FFF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "path-2",
  x: 6,
  y: 6,
  width: 52,
  height: 52,
  rx: 26
}), /*#__PURE__*/React.createElement("filter", {
  x: "-47.1%",
  y: "-27.9%",
  width: "194.2%",
  height: "194.2%",
  filterUnits: "objectBoundingBox",
  id: "filter-3"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 10,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.615563525   0 0 0 0 0.706663359   0 0 0 0 0.790930707  0 0 0 0.223093313 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M32.1526959,19.0017627 C38.3366359,19.0017627 43.4954608,23.4103456 44.6488364,29.2603802 L44.6488364,29.2603802 L44.7343151,29.7423209 C44.8362417,30.392659 44.8895909,31.0599585 44.8895909,31.739424 C44.8898037,31.8819026 44.8876138,32.0242498 44.8830343,32.1664069 L44.8837239,32.1508209 L44.8837239,32.1508209 L44.8903571,31.7360369 C44.8903571,30.8892627 44.8070622,30.0597696 44.6488364,29.2570276 C45.9970046,29.7317051 46.970553,31.019977 46.970553,32.521394 L46.970553,32.521394 L46.970553,33.7121659 C46.9640899,35.556371 45.517212,37.073894 43.6754263,37.1681106 L43.676,37.1677627 L43.6754263,37.1714977 C42.1513018,40.3886175 39.3568779,42.82553 35.9624885,43.8950576 C35.8830563,45.388961 34.6456722,46.5753034 33.1294931,46.5806452 L33.1294931,46.5806452 L30.5729608,46.5806452 C29.7600576,46.5778111 28.9870046,46.2285599 28.4473848,45.6206106 C27.9079032,45.0127995 27.6530069,44.2036982 27.7465668,43.3962212 C27.7611092,43.401603 27.7756639,43.4069589 27.7902309,43.4122889 C27.9561567,42.6629466 28.4187813,42.0091233 29.0781452,41.6033065 L29.077,41.6037627 C29.4558669,41.3693851 29.892466,41.2222039 30.3610539,41.1890636 L30.5637673,41.1819223 L33.1227189,41.1819223 C33.7229954,41.1812673 34.3077189,41.3724309 34.7915899,41.7273502 C33.0573734,42.1817008 31.2377982,42.180373 29.5084802,41.7270843 C30.352018,41.9492844 31.2393261,42.0687903 32.1526959,42.0687903 C33.0653456,42.0687903 33.952212,41.9514862 34.7957719,41.7273502 L34.793,41.7267627 C37.2532258,41.0734202 39.3839193,39.5374758 40.7815862,37.4178972 L40.9597005,37.1381452 C41.1205184,37.1615092 41.2879032,37.1747465 41.4543894,37.1747465 L41.4543894,37.1747465 C41.2911521,37.1747465 41.123871,37.1615092 40.9630876,37.1381452 C41.9266475,35.5659793 42.4853111,33.7163479 42.4853111,31.7360369 C42.4853111,30.8126037 42.3612327,29.9165438 42.1338825,29.0629954 L42.134,29.0657627 C40.9805147,24.7452652 37.0957356,21.5406449 32.4443856,21.4116438 L32.1526959,21.4076037 C27.3593318,21.4076037 23.3321774,24.6678226 22.160553,29.0937903 L22.160553,29.0937903 L22.160553,29.0971774 C21.9394611,29.9418528 21.8191475,30.8265799 21.8191475,31.738629 C21.8178619,32.5212691 22.0099054,33.5064512 22.3952779,34.6941755 C22.4503363,34.8639581 22.481432,35.0405956 22.4876361,35.2189746 C22.5244228,36.276647 21.6968314,37.1638815 20.639159,37.2006682 L20.641,37.1997627 L20.6424078,37.2014631 L20.4583641,37.2014631 C18.5504263,37.1963479 17.0050115,35.6510369 17,33.7430991 L17,33.7430991 L17,32.5521889 C17,30.9200576 18.144182,29.5443088 19.6689977,29.1837212 L19.6689977,29.1837212 C20.8560862,23.3710938 25.9921279,19.0017627 32.1526959,19.0017627 Z M32.4891244,33.9762558 C33.488318,33.9762558 33.9880184,34.4759217 33.9880184,35.4751152 C33.9880184,36.474447 33.488318,36.9741129 32.4891244,36.9741129 L29.491129,36.9741129 C28.4919355,36.9741129 27.9922696,36.474447 27.9922696,35.4751152 C27.9922696,34.4759217 28.4919355,33.9762558 29.491129,33.9762558 L32.4891244,33.9762558 Z M28.2587788,26.4107604 C28.8250115,26.4107604 29.2855184,26.8720968 29.2855184,27.4375 L29.2855184,30.4411636 C29.2814747,31.0078111 28.8220392,31.4657604 28.2553917,31.4679378 L27.0013018,31.4679378 C26.4347926,31.4665553 25.9759101,31.0076728 25.9745622,30.4411636 L25.9745622,27.4375 C25.9745622,26.8720968 26.4358986,26.4107604 27.0013018,26.4107604 L28.2587788,26.4107604 Z M34.9389977,26.4107604 C35.5044355,26.4107604 35.9657373,26.8720968 35.9657373,27.4375 L35.9657373,30.4411636 C35.9657373,31.0073963 35.5044355,31.4679378 34.9389977,31.4679378 L33.6815207,31.4679378 C33.1147696,31.4671083 32.6553341,31.0080876 32.6539862,30.4411636 L32.6539862,27.4375 C32.6539862,26.8720968 33.1161175,26.4107604 33.6815207,26.4107604 L34.9389977,26.4107604 Z",
  id: "path-4"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-23.4%",
  y: "-18.1%",
  width: "146.7%",
  height: "150.8%",
  filterUnits: "objectBoundingBox",
  id: "filter-5"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0.431802536   0 0 0 0 0.830389493  0 0 0 0.30629917 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "\\u591A\\u5E97\\u7BA1\\u7406",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1424.000000, -951.000000)",
  id: "\\u7F16\\u7EC4-3"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(90.000000, 243.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "kefuzhushou",
  transform: "translate(1334.000000, 708.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u77E9\\u5F62"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-3)",
  xlinkHref: "#path-2"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#linearGradient-1)",
  fillRule: "evenodd",
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "\\u5F62\\u72B6\\u7ED3\\u5408"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-5)",
  xlinkHref: "#path-4"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-4"
}))))));

var SvgFloatIcon = function SvgFloatIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFloatIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/floatIcon.3be96f70.svg";
export { ForwardRef as ReactComponent };